import { useEffect } from "react";
import "jquery/dist/jquery.min.js";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-buttons/js/dataTables.buttons.js";
import "datatables.net-buttons/js/buttons.colVis.js";
import "datatables.net-buttons/js/buttons.html5.js"; // Required for Excel export
import "datatables.net-buttons/js/buttons.print.js";
import "datatables.net-buttons-dt/css/buttons.dataTables.min.css";
import $ from "jquery";
import "./datatable.css";
import { Link } from "react-router-dom";

import JSZip from "jszip";
import { BaseUrl } from "../../helper/BaseUrl";
window.JSZip = JSZip;

export default function DataTable({data,tableHeader,tbody,editPath,onDelete,showAction = true,}) {
  // useEffect(() => {
  //   // Initialize datatable
  //   $(document).ready(function () {
  //     setTimeout(function () {
  //       $("#example").DataTable({
  //         paging: false,
  //         pagingType: "full_numbers",
  //         pageLength: 5,
  //         processing: true,
  //         dom: "Bfrtip",
  //         buttons: ["copy", "csv", "excel", "print"],
  //       });
  //     }, 500);
  //   });
  // }, []);

  useEffect(() => {
    // Initialize datatable
    const initializeDataTable = () => {
      $("#example").DataTable({
        destroy: true, // Destroy any existing DataTable before initializing
        paging: false,
        pagingType: "full_numbers",
        pageLength: 5,
        processing: true,
        dom: "Bfrtip",
        buttons: ["copy", "csv", "excel", "print"],
      });
    };
  
    if (data && data.length > 0) {
      setTimeout(initializeDataTable, 500); // Initialize DataTable only when data is available
    }
  
    return () => {
      // Cleanup: Destroy DataTable instance on component unmount
      if ($.fn.DataTable.isDataTable("#example")) {
        $("#example").DataTable().destroy();
      }
    };
  }, [data]);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const monthNames = [
      "Jan", "Feb", "Mar", "Apr", "May", "June", "July",
      "Aug", "Sep", "Oct", "Nov", "Dec",
    ];
    return `${date.getDate()} ${monthNames[date.getMonth()]} ${date.getFullYear()}`;
  };

  return (
    <table
      id="example"
      className="my-data-table table table-hover table-bordered"
    >
      <thead>
        <tr>
          <th>S/N</th>
          {tableHeader.map((header, index) => (
            <th key={index}>{header}</th>
          ))}
            {showAction && <th>Action</th>} 
        </tr>
      </thead>
      <tbody>
        {data?.map((item, rowIndex) => (
          <tr key={rowIndex}>
            <td>{rowIndex + 1}</td>
            {tbody.map((body, colIndex) => (
              <td key={colIndex}>
                {/* Conditionally render "subject" or "null" */}
                {body === "subject"  && !item[body] ? "N/A" : body === "createdAt" ? formatDate(item[body]):  body === "logo"? 
                <img src={BaseUrl+item[body]} alt="logo"/> : item[body]}
                {}
                {body === "phoneNumber" && !item[body] ? "N/A" : ""}
                {body === "source_url" && !item[body] ? "N/A" :""}
              </td>
            ))}
             {showAction && (
            <td>
              <div className="table-btn-group">
                <Link
                  to={`/admin/${editPath}/${item._id}`}
                  className="edit-btn"
                >
                  Edit
                </Link>
                {onDelete &&
                <Link className="delete-btn" onClick={() => onDelete(item._id)}>
                  Delete
                </Link>}
              </div>
            </td>
             )}
          </tr>
        ))}
      </tbody>
    </table>
  );
}
